import { SATError, SATErrorType } from "@sadtx/sat-error";

// MARK:- 서버 연결 실패 판별
// 시간 위변조 검사(/time-zone/check)는 실제 시간 불일치일 때만 400 을 준다.
// 서버가 꺼져 있거나(네트워크 에러 800001) 게이트웨이·서버 오류(5xx)로 실패한 경우는
// 시간 위변조가 아니라 "서버에 연결할 수 없음" 으로 안내해야 한다.
const SERVER_UNREACHABLE_TYPES: ReadonlySet<SATErrorType> = new Set([
  SATErrorType.NetworkError,
  SATErrorType.InternalServerError,
  SATErrorType.BadGateway,
  SATErrorType.ServiceUnavailable,
  SATErrorType.GatewayTimeout,
]);

export const isServerUnreachableError = (error: SATError | null | undefined): boolean =>
  !!error && SERVER_UNREACHABLE_TYPES.has(error.type);
